import { getCountries, type CountryCode } from 'libphonenumber-js';

import { DEFAULT_COUNTRY, countryName, dialCode, flagEmoji } from '@/lib/phone';

export const sortedCountries = (
  locale: string,
  priority: CountryCode[] = [DEFAULT_COUNTRY],
): { code: CountryCode; name: string; dial: string; flag: string }[] => {
  const collator = new Intl.Collator(locale);

  return getCountries()
    .map((code) => ({
      code,
      name: countryName(code, locale),
      dial: dialCode(code),
      flag: flagEmoji(code),
    }))
    .sort((a, b) => {
      const aPriority = priority.indexOf(a.code);
      const bPriority = priority.indexOf(b.code);
      if (aPriority !== bPriority) {
        if (aPriority === -1) return 1;
        if (bPriority === -1) return -1;
        return aPriority - bPriority;
      }
      return collator.compare(a.name, b.name);
    });
};
